import { exists } from '@treasury/utils';
import { css, nothing, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-icon';
@customElement(tagName)
export class TmIcon extends TmBaseComponent {
    @property({ type: Object })
    public icon?: TemplateResult | TemplateResult<2>;

    @property({ reflect: true })
    public width?: string;

    @property({ reflect: true })
    public height?: string;

    @property({ reflect: true })
    public color?: string;

    protected firstUpdated() {
        this.setIconColor();
        this.setIconSize();
    }

    protected updated() {
        this.setIconColor();
        this.setIconSize();
    }

    protected render() {
        if (!this.icon) {
            return nothing;
        }

        return this.icon;
    }

    private setIconSize() {
        const svg = this.shadowRoot?.querySelector('svg');
        if (!svg) {
            return;
        }

        if (exists(this.width)) {
            svg.style.width = this.width;
        }

        if (exists(this.height)) {
            svg.style.height = this.height;
        }
    }

    private setIconColor() {
        const path = this.shadowRoot?.querySelectorAll('path');
        const { color } = this;
        if (color && path) {
            path.forEach(pathItem => {
                pathItem.style.fill = color;
            });
        }
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: inline-block;
                }
                path {
                    fill: var(--icon-fill-color, var(--brand-primary));
                }
                svg {
                    transform: var(--icon-svg-transform, scale(1));
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmIcon;
    }
}
